module.exports = __webpack_public_path__ + "static/media/noDocs.66f71a61.svg";